<template>
  <div>
    <serviceTeacher-list v-show="tabType === 1" @handleShow="handleShow" :isServiceTeacher="1" />
    <serviceTeacher-show v-if="tabType === 2" :rowItem="rowItem" :isServiceTeacher="1"  @handleShow="handleShow" />
  </div>
</template>

<script>
import serviceTeacherList from '../technicalManage/list.vue'
import serviceTeacherShow from '../technicalManage/show.vue'
export default {
  components: {
    serviceTeacherList,
    serviceTeacherShow
  },
  data() {
    return {
      tabType: 1,
      rowItem: null,
    }
  },
  methods: {
    handleShow(row, type) {
      this.tabType = type
      this.rowItem = { ...row }
    }
  }
}
</script>

<style>
</style>
